export function daemonRunPath(daemonId: number, runId: number): string;
export function daemonRunPath(daemonId: number | null | undefined, runId: number): string | null;
export function daemonRunPath(daemonId: number | null | undefined, runId: number): string | null {
  if (Number.isFinite(daemonId)) return `/admin/daemons/${daemonId}?tab=runs&runId=${runId}`;
  return null;
}
